export default class FaqHandler {
  constructor() {
    if (this.dependencies()) {
      this.addEventListseners();
    }
  }

  dependencies = () => {
    this.items = document.querySelectorAll(".renovare-500-faq-widget__item");
    if (!this.items || this.items.length <= 0) return false;

    return true;
  };

  addEventListseners = () => {
    this.items.forEach((item) => {
      item.addEventListener("click", () => this.handleQuestionClick(item));
    });
  };

  handleQuestionClick = (item) => {
    let question = item.querySelector(".renovare-500-faq-widget__question");
    let answer = item.querySelector(".renovare-500-faq-widget__item-answer");
    let chevron = item.querySelector("img");

    if (item.dataset.isActive == "true") {
      answer.classList.add("hidden");
      item.dataset.isActive = "false";
      chevron.classList.remove("rotate-180");
    } else {
      answer.classList.remove("hidden");
      item.dataset.isActive = "true";
      chevron.classList.add("rotate-180");
    }
  };
}
